<div *ngIf="audioURL" class="row ml-1 background-audio" style="margin-right: 0;">
        <div class="col-1">
            <i class="material-icons" style="font-size: 18px;" (click)="playAudio()">
                {{audio.paused ? 'play_arrow' : 'pause'}}
            </i>
        </div>
        <div class="col-2">
            <span> {{audio ? toSeconds(audio.currentTime) : '0:00'}} </span>
        </div>
        <div class="col-6">
            <input class="slider-audio" type="range" min="0" [max]="duration" [(ngModel)]="currentTimeRange" step="0.25"
                (change)="audio.currentTime = currentTimeRange;">
        </div>
        <div class="col-2">
            <i class="material-icons" style="font-size: 18px;" (click)="muteAudio()">
                {{audio.muted ? 'volume_off' : 'volume_up'}}
            </i>
        </div>
        <audio [src]="audioURL" style="display: none;" (ended)="stopedAudio()" #audio
            (durationchange)="getDuration($event)" controls="true"></audio>
</div>